/**
 * MOJITO: language selector for the mobile header bar.
 * See snippets/mojito-locale-mobile.liquid for why this is a separate control
 * rather than a relocation of the theme's <popout-select>.
 *
 * All handlers are delegated on document so the control keeps working if the
 * header section is re-rendered (theme editor) and re-mounted.
 */
(function () {
  'use strict';

  var SRC = '.mojito-locale-src';
  var FORM = '.mojito-locale';
  var TOGGLE = '[data-mojito-locale-toggle]';
  var LIST = '[data-mojito-locale-list]';
  var BAR = '.site-header > .wrapper';
  var BURGER = '.mobile-menu__button--burger';
  var LEFT_CLASS = 'mojito-locale--left';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function setOpen(form, open) {
    var toggle = form.querySelector(TOGGLE);
    var list = form.querySelector(LIST);
    if (!toggle || !list) return;

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      list.removeAttribute('hidden');
    } else {
      list.setAttribute('hidden', '');
    }
  }

  function closeAll(except) {
    var forms = document.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i] !== except) setOpen(forms[i], false);
    }
  }

  // Held across mounts: the theme editor replaces the whole header section, which
  // would otherwise discard our form along with the old header markup.
  var formNode = null;

  /**
   * Move our form out of its end-of-body holder and into the header bar, on the
   * LEFT, immediately after the burger button.
   *
   * It previously mounted inside .mobile-menu (the right-hand search + cart
   * stack) ahead of the search icon. To put it back there, set BAR to
   * '.site-header .mobile-menu', insert at bar.firstChild, stop adding
   * LEFT_CLASS, and drop the matching block at the bottom of
   * mojito-locale-mobile.css.
   *
   * LEFT_CLASS is what takes the control out of the wrapper's flex flow (see
   * the CSS); without it, inserting here would push the centred wordmark off
   * centre by the width of "EN".
   *
   * The node carries no custom elements, so moving it has no lifecycle cost.
   */
  function mount() {
    var bar = document.querySelector(BAR);
    if (!bar) return;

    if (!formNode) {
      var holder = document.querySelector(SRC);
      formNode = holder ? holder.querySelector(FORM) : null;
    }
    if (!formNode) return;

    formNode.classList.add(LEFT_CLASS);

    var burger = bar.querySelector(BURGER);

    // Already in place: same parent AND still sitting right after the burger.
    if (formNode.parentNode === bar && formNode.previousElementSibling === burger) return;

    bar.insertBefore(formNode, burger ? burger.nextSibling : bar.firstChild);
  }

  document.addEventListener('click', function (evt) {
    var toggle = closest(evt.target, TOGGLE);

    if (toggle) {
      var form = closest(toggle, FORM);
      if (!form) return;
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAll(form);
      setOpen(form, !isOpen);
      return;
    }

    // Any click outside an open control closes it. Clicks on an option are
    // submit buttons, so the page navigates before this matters.
    if (!closest(evt.target, FORM)) closeAll(null);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' && evt.key !== 'Esc') return;

    var open = document.querySelector(TOGGLE + '[aria-expanded="true"]');
    if (!open) return;

    closeAll(null);
    open.focus();
  });

  document.addEventListener('focusout', function (evt) {
    var form = closest(evt.target, FORM);
    if (!form) return;

    // relatedTarget is null when focus leaves the document entirely; keep the
    // list open in that case so returning to the tab doesn't lose it.
    if (evt.relatedTarget && !form.contains(evt.relatedTarget)) setOpen(form, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  // Theme editor re-renders the header section without reloading the page.
  document.addEventListener('shopify:section:load', mount);
})();
